import { server_connection } from 'config';
import { getQuiz } from './quiz.actions';
import history from 'history.js';
import { updateUserRoles } from '../../../../../auth/store/actions';
import store from 'store';

export const GET_STUDENT_QUIZ             = '[STUDENT QUIZ] GET STUDENT QUIZ';
export const UPDATE_STUDENT_QUESTION      = '[STUDENT QUIZ] UPDATE STUDENT QUESTION';
export const UPDATE_STUDENT_QUIZ          = '[STUDENT QUIZ] UPDATE STUDENT QUIZ';
export const GET_NEXT_EVENT_FOR_CONTINUE  = '[STUDENT QUIZ] GET NEXT EVENT FOR CONTINUE';

export function getStudentQuiz(student_quiz_id) {
    return (dispatch) => {
        fetch(server_connection + '/quiz/student/get/' + student_quiz_id)
            .then((response) => response.json())
            .then((studentQuiz) => {
                dispatch(getQuiz(studentQuiz.header.quiz_id));
                
                dispatch({
                    type: GET_STUDENT_QUIZ,
                    payload: studentQuiz
                });
            });
    }
}

export function updateStudentQuiz(update_data) {
    return (dispatch) => {
        dispatch({
            type: UPDATE_STUDENT_QUIZ,
            payload: update_data
        })
    }
}

export function updateStudentQuestion(question_id, student_quiz_id, question_type_id, update_data) {
    return (dispatch) => {
        dispatch({
            type: UPDATE_STUDENT_QUESTION,
            payload: { question_id, student_quiz_id, question_type_id, update_data }
        });
    }
}

export function saveStudentGrades(studentQuiz, auth_id, goBack=false) {
    return (dispatch) => {
        fetch(server_connection + '/quiz/student/grade/',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ studentQuiz, auth_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                if(goBack) {
                    history.goBack();
                }
            });
    }
}

export function getNextEventForContinueButton(cur_event_id, fromQuiz, student_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/scheduled_course/next_course_event_for_continue/' + cur_event_id + '/' + fromQuiz + '/' + student_id)
            .then((response) => response.json())
            .then((responseData) => {
                return dispatch({
                    type: GET_NEXT_EVENT_FOR_CONTINUE,
                    payload: responseData
                });
            });
    }
}


// WEBPACK FOOTER //
// src/main/content/quiz/store/actions/quizScore.actions.js